import * as React from "react";
import { trim } from "lodash";
import { Skeletal } from "../skeleton";
import { Icon } from "../icon/icon";
import { Space, spaceValues } from "../common-interfaces/space";

const classNames = require("classnames");
const md5 = require("md5");
const css = require("./gravatar.scss");
const defaultImg = encodeURIComponent("https://mobilecenter.azureedge.net/assets/default-avatar-128w.png");

export interface GravatarProps extends Skeletal, React.HTMLAttributes<HTMLElement> {
  src?: string;
  email?: string;
  size?: number;
  gravatarSize?: number;
  alt?: string;
  styles?: any;
}

export class Gravatar extends React.PureComponent<GravatarProps, {}> {
  public static displayName: "Avatar";

  public static defaultProps: any = {
    email: "",
    size: spaceValues[Space.Large],
    gravatarSize: 90, // by default just load one gravatar size for caching reasons
    styles: css
  };

  public getGravatar() {
    const { src, gravatarSize, size } = this.props;
    const email = this.props.email || "";
    if (src) {
      return src;
    }

    const gravatarEmail = trim(email).toLowerCase();
    const id = email.includes("@") ? md5(gravatarEmail) : gravatarEmail;
    return `https://secure.gravatar.com/avatar/${id}?s=${gravatarSize || size}&d=${defaultImg}`;
  }

  get alt() {
    return this.props.alt || this.props.email;
  }

  public render() {
    const { email, size, gravatarSize, alt, styles, skeleton, ...passthrough } = this.props;
    if (this.props.skeleton) {
      return <Icon skeleton style={{ width: size, height: size }} />;
    }
    const className = classNames(styles.avatar, this.props.className);

    return (
      <div {...passthrough} className={className}>
        <img src={this.getGravatar()} width={this.props.size} height={this.props.size} alt={this.alt} />
      </div>
    );
  }
}
